/*----------------------------------
- SUPPORT CONFIG
----------------------------------*/

/**
 * Centralized support entry-points (used by both client and server).
 * Keep these URLs stable and environment-agnostic.
 */
export const SUPPORT_CHAT_LINK = 'https://wa.me/33601711555';
